module.exports = __webpack_public_path__ + "static/media/idea-icon.0f906b0a.svg";